import { Stack, Typography, Box, useTheme } from "@mui/material";
import { testId } from "tests/testIdStrings";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useAppContext } from "context/AppContext";
import { useTextToSpeech } from "hooks/useTextToSpeech";
import { useAppIntl } from "services/useAppIntl";
import { TextToSpeech } from "@STRSERVICE/optima-component-library";
import FormattedMessage from "../FormattedMessage";
const img = process.env.PUBLIC_URL + "/img/illustrations/woman-skateboard.svg";

interface INoContent {
  heading?: string;
}

export const NoContent = ({ heading }: INoContent) => {
  const textToSpeech = useTextToSpeech();
  const { soundSupport } = useAppContext();
  const intl = useAppIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={!isMobile ? { paddingTop: 4, paddingLeft: 2, paddingBottom: 6, boxShadow: theme.shadows[2] } : null}>
      {heading && (
        <Typography color={theme.palette.text.primary} variant="h1">
          {heading}
          {soundSupport && <TextToSpeech text={heading} player={textToSpeech} />}
        </Typography>
      )}
      <Stack
        alignItems="center"
        mt={4}
        spacing={5}
        data-testid={testId.common.noContent}
        sx={{ position: "relative", " > img": { maxHeight: isMobile ? 360 : "none" } }}
      >
        <img src={img} alt="Woman skateboarding" />

        <Typography
          color={theme.palette.text.primary}
          variant="body1"
          sx={
            isMobile
              ? {
                  position: "absolute",
                  backgroundColor: "rgba(0, 0, 0, 0.35)",
                  color: "white",
                  top: "40%",
                  px: 2,
                  py: 1,
                  borderRadius: 1,
                }
              : null
          }
        >
          <FormattedMessage id="theory.material.activity.no-content" />
          {soundSupport && (
            <TextToSpeech
              text={intl.formatMessage({ id: "theory.material.activity.no-content" })}
              player={textToSpeech}
            />
          )}
        </Typography>
      </Stack>
    </Box>
  );
};
